enum CartTypes {
  ScanAndPay = 'ScanAndPay',
  OrderAhead = 'OrderAhead',
  TouchlessCoffee = 'TouchlessCoffee',
}

export default CartTypes;
